/*
* 运单状态枚举
* */
export enum OverallStatus {
    CREATED = 10,                   // 已创建
    CANCELLED = 20,                 // 已取消
    ARRIVED_ORIGIN_HUB = 25,        // 已入库_始发地HUB
    LINEHAUL_PENDING_SHIPMENT = 26, // 干线待发运
    FEEDER_PENDING_SHIPMENT = 28,   // 支线待发运
    HANDED_OVER = 27,               // 已交接
    IN_TRANSIT = 30,                // 运输中
    ARRIVED_DESTINATION_HUB = 35,   // 已入库_目的地HUB
    ARRIVED_WHS = 38,               // 已入库_WHS
    WAITING_FOR_DELIVERY = 40,      // 待派件
    DELIVERY_IN_PROGRESS = 50,      // 派件中
    PRE_DELIVERED = 55,             // 预妥投
    DELIVERED = 60,                 // 派件成功
    DELIVERY_FAILED = 70,           // 派件失败
    PENDING_INTERCEPTION = 75,      // 待拦截
    INTERCEPTED = 78,               // 已拦截
    RETURNED = 80,                  // 已退件
    RETURN_STARTED = 81,            // 退件中
    HOLDING = 82,              //留仓中
    RETURN_ARRIVED_DESTINATION_HUB = 83, //退件到达目的地仓
    PICKUP_FAILED = 84,            //揽收失败
    DESTROYED = 85,                 //已销毁
    MISSING = 86,                   // 已丢失
    DAMAGED = 87                  //已破损
}

/*
* POD审核状态枚举 - 匹配后端PodReviewStatus
*/
export enum PODReviewStatus {
    NOT_REVIEWED = 0,        // 未审核
    MACHINE_APPROVED = 1,    // 机审通过
    MACHINE_DISAPPROVED = 2, // 机审不通过
    MANUAL_PENDING = 3,      // 待人审
    MANUAL_APPROVED = 4,     // 人审通过
    MANUAL_DISAPPROVED = 5,  // 人审不通过
    MANUAL_CORRECTED = 6     // 人审误判修正
}

export enum Rule {
    DELIVERY_DRIVER = 'DELIVERY_DRIVER',
    DSP_MANAGER = 'DSP_MANAGER',
    DSP_OWNER_TEAM = 'DSP_OWNER_TEAM',
    HEADQUARTERS_STAFF = 'HEADQUARTERS_STAFF',
    WAREHOUSE_MANAGER = 'WAREHOUSE_MANAGER',
    HUB_MANAGER = 'HUB_MANAGER',
}

export enum ExceptionReasonCodeStartsWith {
    ERDL = 'ERDL',
    ERDSP = 'ERDSP',
    ERWHS = 'ERWHS',
    ERHUB = 'ERHUB',
    ERDL001 = 'ERDL001',
    ERDL002 = 'ERDL002',
    ERDL003 = 'ERDL003',
    ERDL004 = 'ERDL004',
}